var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"atom-text",class:( _obj = {}, _obj[("atom-text--" + _vm.size)] = true, _obj['atom-text--bold'] =  _vm.bold, _obj['atom-text--color-mute'] =  _vm.mute, _obj )},'component',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }